// @ai-generated 2026-07-20T14:22:45Z by malte.ulfers@tngtech.com using Claude Opus 4.7 (1M context)
import { HttpAgent } from '@ag-ui/client';
import { AGENTIC_ORCHESTRATOR_API } from '@Constants/backendConstants';
import { useToken } from '@synqo/frontend-component-library';
import { useMemo, useRef } from 'react';

/**
 * Returns a memoized HttpAgent pointed at the AgenticOrchestrator's /agent AG-UI endpoint.
 *
 * The custom `fetch` attaches the current MSAL bearer to every request, matching the token
 * pattern used by useSynqoHttpConfig for regular requests and by SignalProvider for the
 * long-lived hub connection.
 *
 * The agent is stable across renders as long as the threadId is stable — each conversation
 * gets its own agent instance so AG-UI's per-agent state (subscribers, messages) stays scoped.
 */
export function useAgentClient(threadId: string): HttpAgent {
    const { getToken } = useToken();
    const getTokenRef = useRef(getToken);
    getTokenRef.current = getToken;

    return useMemo(
        () =>
            new HttpAgent({
                url: `${AGENTIC_ORCHESTRATOR_API}/agent`,
                threadId,
                fetch: async (url, requestInit) => {
                    const token = await getTokenRef.current();
                    const headers = new Headers(requestInit.headers);
                    headers.set('Authorization', `Bearer ${token}`);
                    return fetch(url, { ...requestInit, headers, credentials: 'include' });
                },
            }),
        [threadId],
    );
}
